import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/api/auth.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserDataService } from '../../../../core/services/user-data.service';
import { RecentUploadsService } from '../../../../core/services/recent-uploads.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { ProfileImageService } from '../../../../core/services/profile-image.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router, private userData: UserDataService, private recentUploads: RecentUploadsService, private notificationService: NotificationService, private profileImage: ProfileImageService) { }

  async ngOnInit() {
    try {
      await firstValueFrom(this.authService.logOut());

      this.userData.clearUser();
      this.recentUploads.clearUploads();

      this.notificationService.disconnect();

      this.profileImage.resetProfileImage();

      localStorage.clear();
    } catch (error) {
      // pass
    }
    
    this.router.navigate(['/auth/signup']);
  }

}
